export default __webpack_public_path__ + "static/media/1031.2199abef.png";